import styled from "styled-components";
import theme from "../theme";

const lightSansSerif = `
    font-family: ${theme.font.family.sansSerif};
	font-weight: 300;
`;

export const Wrapper = styled.main`
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	column-gap: 20px;
	width: 100%;
	max-width: 500px;
	padding: 15px;
	box-sizing: border-box;

	${theme.breakpoints.lg} {
		max-width: 1072px;
		grid-template-columns: repeat(10, 1fr);
		column-gap: 20px;
	}
`;

export const Logo = styled.img.attrs({
	src: require("../assets/CLG_White_notext.png"),
})`
	height: 100px;
	margin-top: 30px;
	margin-bottom: 80px;
	grid-column: 1/-1;
	justify-self: center;
`;

export const LogoWithText = styled.img.attrs({
	src: require("../assets/CLG_White.png"),
})`
	height: 150px;
	margin-top: 30px;
	margin-bottom: 80px;
	grid-column: 1/-1;
	justify-self: center;
`;

export const LogoWithTextinBlack = styled.img.attrs({
	src: require("../assets/CLG_Black.png"),
})`
	height: 150px;
	margin-top: 30px;
	margin-bottom: 80px;
	grid-column: 1/-1;
	justify-self: center;
`;

export const Heading = styled.h1`
	font-weight: 600;
	font-size: 48px;
	line-height: 48px;
	margin-bottom: 30px;
	/* text-align: center; */

	${theme.breakpoints.lg} {
		text-align: left !important;
	}
`;

export const Subheading = styled.h3`
	font-weight: 300;
	font-size: 24px;
	line-height: 30px;
	text-align: ${({ center }) => (center ? "center" : "left")};

	${theme.breakpoints.lg} {
		text-align: left !important;
	}

	margin-bottom: 40px;

	> a {
		text-decoration: underline;
		color: inherit;
	}
`;

export const Tag = styled.p`
	font-family: ${theme.font.family.sansSerif};
	font-style: normal;
	font-weight: 500;
	font-size: 24px;
	line-height: 30px;

	color: #2e2e2e;
`;

export const Title = styled.h2`
	${lightSansSerif}
	font-size: 30px;
	line-height: 30px;
	padding-bottom: 15px;
	border-bottom: 1px solid black;
	margin-bottom: 10px;
`;

export const Subtitle = styled.h4`
	font-family: ${theme.font.family.sansSerif};
	font-weight: 600;
	font-size: 16px;
	line-height: 30px;
	color: ${theme.color.grey};
	padding-bottom: 1px;
	${({ borderless }) =>
		!borderless && `border-bottom: 1px solid ${theme.color.grey}`}
`;

export const Selectable = styled.div`
	border-style: solid;
	border-width: 2px;
	border-color: transparent;
	will-change: border-color;
	transition: border-color 0.23s;

	${({ selected }) =>
		selected ? `border-color: #0085FF` : `cursor: pointer`};
`;
